import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

import { getFieldStatusCounts } from '@/modules/home/components/PageContent/Operations/Fields/logic';
import { Typography } from '@/shared/components/atoms';
import { EntityType } from '@/shared/constant/enums';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import Location from '~/images/shared/Location.svg';

const statusColors = {
  active: { bg: 'bg-tertiary-70', title: 'Active' },
  completed: { bg: 'bg-secondary-20', title: 'Completed' },
  inactive: { bg: 'bg-background-disable', title: 'Inactive' },
};

const FieldsHeader: React.FC<{
  counts: ReturnType<typeof getFieldStatusCounts> | undefined;
}> = ({ counts }) => {
  const { t } = useTranslation();

  const [selectedAsset] = useStore((store) => store?.asset);

  return (
    <div className='flex flex-col items-start justify-between gap-2 tablet:flex-row tablet:items-center'>
      <div className='flex items-center gap-8'>
        <Location width='24' height='24' />
        <Typography weight='bold'>
          {t(
            selectedAsset?.entityTypeId === EntityType.FARM
              ? 'work-locations'
              : 'Lines'
          )}
        </Typography>
      </div>
      <div className='flex gap-16'>
        {Object.entries(statusColors).map(([key, value]) => (
          <div className='flex items-center gap-8' key={key}>
            <div
              className={classNames(' h-12 w-12 rounded-full', value.bg)}
            ></div>
            <Typography>{`${t(value.title)} (${
              counts ? counts[key as keyof typeof counts] : 0
            })`}</Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export { FieldsHeader };
